import { Page, PageBody, PageHeader } from "@/components/app-layout";
import { FolderList } from "@/components/folder/FolderList";
import { useExpertEditData } from "@/data/use-expert-edit-data";
import { useFoldersData } from "@/data/use-folders-data";
import { useGroupSlug } from "@/hooks/use-group-slug";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";

export const ExpertFoldersPage = () => {
  const groupSlug = useGroupSlug();
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();
  const { expertUuid } = useExpertEditData({ groupUuid, kitUuid });
  const { folders: expertFolders } = useFoldersData({ expertUuid });

  if (!groupUuid || !groupSlug || !kitUuid) {
    return null;
  }

  return (
    <Page>
      <PageHeader>
        <PageHeader.Title>Expert Knowledge</PageHeader.Title>
      </PageHeader>

      <PageBody>
        <FolderList
          groupSlug={groupSlug}
          groupUuid={groupUuid}
          kitUuid={kitUuid}
          folderUuids={expertFolders.map((folder) => folder.uuid)}
        />
      </PageBody>
    </Page>
  );
};
